export const urlRegex = /(https?:\/\/[^\s]+)/g;
